import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import axios from 'axios'
import './plugins/fontawesome'
import './plugins/bootstrap-vue'
import App from './App.vue'
import ScrollFixedHeader from 'vuejs-scroll-fixed-header'
import VueParticles from 'vue-particles'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFontAwesome, faHtml5, faCss3Alt, faVuejs, faAdobe, faWordpress, faJoomla, faBootstrap, faJsSquare, faPhp  } from '@fortawesome/free-brands-svg-icons'
library.add(faUserSecret)
library.add(faFontAwesome,faHtml5, faCss3Alt, faVuejs, faAdobe, faWordpress, faJoomla, faBootstrap, faJsSquare, faPhp)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(ScrollFixedHeader)
Vue.use(VueParticles)
Vue.prototype.$axios = axios
new Vue({
  render: h => h(App),
}).$mount('#app')
